function _classPrivateFieldLooseBase(e, t) { if (!{}.hasOwnProperty.call(e, t)) throw new TypeError("attempted to use private field on non-instance"); return e; }
var id = 0;
function _classPrivateFieldLooseKey(e) { return "__private_" + id++ + "_" + e; }
import { mediaQueryLarge, isMobileBreakpoint } from '@theme/utilities';

// Accordion
// Still extends HTMLElement over Component so that refs are still available to parent components (e.g. SortingFilterComponent)
var _disableOnMobile = _classPrivateFieldLooseKey("disableOnMobile");
var _disableOnDesktop = _classPrivateFieldLooseKey("disableOnDesktop");
var _closeWithEscape = _classPrivateFieldLooseKey("closeWithEscape");
var _controller = _classPrivateFieldLooseKey("controller");
var _handleMediaQueryChange = _classPrivateFieldLooseKey("handleMediaQueryChange");
var _setDefaultOpenState = _classPrivateFieldLooseKey("setDefaultOpenState");
var _handleKeyDown = _classPrivateFieldLooseKey("handleKeyDown");
class AccordionCustom extends HTMLElement {
  constructor(...args) {
    super(...args);
    /**
     * Handles keydown events for the accordion
     *
     * @param {KeyboardEvent} event - The keyboard event.
     */
    Object.defineProperty(this, _handleKeyDown, {
      value: _handleKeyDown2
    });
    /**
     * Sets the default open state of the accordion based on the `open-by-default-on-mobile` and `open-by-default-on-desktop` attributes.
     */
    Object.defineProperty(this, _setDefaultOpenState, {
      value: _setDefaultOpenState2
    });
    Object.defineProperty(this, _closeWithEscape, {
      get: _get_closeWithEscape,
      set: void 0
    });
    Object.defineProperty(this, _disableOnDesktop, {
      get: _get_disableOnDesktop,
      set: void 0
    });
    Object.defineProperty(this, _disableOnMobile, {
      get: _get_disableOnMobile,
      set: void 0
    });
    Object.defineProperty(this, _controller, {
      writable: true,
      value: new AbortController()
    });
    /**
     * Handles the click event.
     * @param {Event} event - The event.
     */
    this.handleClick = event => {
      const isMobile = isMobileBreakpoint();
      const isDesktop = !isMobile;

      // Stop default behaviour from the browser
      if (isMobile && _classPrivateFieldLooseBase(this, _disableOnMobile)[_disableOnMobile] || isDesktop && _classPrivateFieldLooseBase(this, _disableOnDesktop)[_disableOnDesktop]) {
        event.preventDefault();
        return;
      }
    };
    /**
     * Handles the media query change event.
     */
    Object.defineProperty(this, _handleMediaQueryChange, {
      writable: true,
      value: () => {
        _classPrivateFieldLooseBase(this, _setDefaultOpenState)[_setDefaultOpenState]();
      }
    });
  }
  /** @type {HTMLDetailsElement} */
  get details() {
    const details = this.querySelector('details');
    if (!(details instanceof HTMLDetailsElement)) throw new Error('Details element not found');
    return details;
  }

  /** @type {HTMLElement} */
  get summary() {
    const summary = this.details.querySelector('summary');
    if (!(summary instanceof HTMLElement)) throw new Error('Summary element not found');
    return summary;
  }
  connectedCallback() {
    const {
      signal
    } = _classPrivateFieldLooseBase(this, _controller)[_controller];
    _classPrivateFieldLooseBase(this, _setDefaultOpenState)[_setDefaultOpenState]();
    this.addEventListener('keydown', _classPrivateFieldLooseBase(this, _handleKeyDown)[_handleKeyDown], {
      signal
    });
    this.summary.addEventListener('click', this.handleClick, {
      signal
    });
    mediaQueryLarge.addEventListener('change', _classPrivateFieldLooseBase(this, _handleMediaQueryChange)[_handleMediaQueryChange], {
      signal
    });
  }

  /**
   * Handles the disconnect event.
   */
  disconnectedCallback() {
    // Disconnect all the event listeners
    _classPrivateFieldLooseBase(this, _controller)[_controller].abort();
  }
}
function _get_disableOnMobile() {
  return this.dataset.disableOnMobile === 'true';
}
function _get_disableOnDesktop() {
  return this.dataset.disableOnDesktop === 'true';
}
function _get_closeWithEscape() {
  return this.dataset.closeWithEscape === 'true';
}
function _setDefaultOpenState2() {
  const isMobile = isMobileBreakpoint();
  this.details.open = isMobile && this.hasAttribute('open-by-default-on-mobile') || !isMobile && this.hasAttribute('open-by-default-on-desktop');
}
function _handleKeyDown2(event) {
  // Close the accordion when used as a menu
  if (event.key === 'Escape' && _classPrivateFieldLooseBase(this, _closeWithEscape)[_closeWithEscape]) {
    event.preventDefault();
    this.details.open = false;
    this.summary.focus();
  }
}
if (!customElements.get('accordion-custom')) {
  customElements.define('accordion-custom', AccordionCustom);
}
